import { api } from "../../ConsumeApiController";
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";


export async function getEventSections(eventId)
{
    const response = await api.get(CompanyRoutes.Events.GetEventSections(eventId));
    return response;
}

export async function toggleSectionStatus(uuid)
{
    const response = await api.get(CompanyRoutes.Events.Sections.ToggleStatus(uuid));
    return response;
}

export async function createSection(payload)
{
    const response = await api.post(CompanyRoutes.Events.Sections.Create,payload);
    return response;
}

export async function updateSection(editingUuid,payload)
{
    const response = await api.put(CompanyRoutes.Events.Sections.Update(editingUuid),payload);
    return response;
}